import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { REQUEST_STATUS_NAMES, getStatusColor } from '../../statusEnums';

RequestStatusBadge.propTypes = {
  requestStatusId: PropTypes.number.isRequired,
};

export default function RequestStatusBadge({ requestStatusId }) {
  return requestStatusId > 0 ? (
    <Box display="flex" alignItems="center" sx={{ gap: 1, ml: 'auto' }}>
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor: getStatusColor(requestStatusId),
        }}
      />
      <Typography sx={{ fontSize: '14px', fontWeight: 400, color: getStatusColor(requestStatusId) }}>
        {REQUEST_STATUS_NAMES[requestStatusId]}
      </Typography>
    </Box>
  ) : null;
}
